module.exports = __webpack_public_path__ + "b6e2a4f55544b9fa0c1d0706eb96e11d.png";